// 讀取後端注入的 deployment-level 功能旗標。
// 來源：layout 的 <script type="application/json" id="deployment-flags">
// （Rails helper：app/helpers/deployment_flags_helper.rb）。
//
// 旗標在頁面載入後不會變動，故解析一次後快取於 module scope。

let cached;

const parseFlags = () => {
  const node = document.getElementById('deployment-flags');
  if (!node) return {};
  try {
    return JSON.parse(node.textContent) || {};
  } catch (err) {
    console.error('Failed to parse #deployment-flags:', err);
    return {};
  }
};

export const getDeploymentFlags = () => {
  if (cached === undefined) {
    cached = parseFlags();
  }
  return cached;
};
